import { useContext, useState, useEffect } from "react";
import { useNetwork } from "wagmi";
import { AppContext } from "./utils";
import NetworkSwitch from "./NetworkSwitch";
import {
  AccountSection,
  Feeds,
  LogIn,
  PointsDetail,
  PointsExchange,
} from "./pages";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom/dist";
import Footer from "./components/Footer";
function App() {
  const userId = localStorage.getItem("userDataID");
  const { account, userLoginStatus, setUserLoginStatus, setUserDatabaseId } =
    useContext(AppContext);
  const [openNetworkSwitch, setOpenNetworkSwitch] = useState(false);
  const { chain } = useNetwork();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (account && chain && chain?.id !== 56) {
  //     setOpenNetworkSwitch(true);
  //   }
  // }, [chain, account]);

  // useEffect(() => {

  // }, []);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const userIdQuery = params.get("userId");

    if (userIdQuery) {
      localStorage.setItem("userDataID", userIdQuery);
      setUserLoginStatus(true);
      setUserDatabaseId(userIdQuery);
      navigate("/feeds");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (userId) {
      setUserLoginStatus(true);
      setUserDatabaseId(userId);
    }
  }, []);
  return (
    <>
      <NetworkSwitch open={openNetworkSwitch} setOpen={setOpenNetworkSwitch} />
      <Routes>
        {userId || userLoginStatus ? (
          <>
            <Route path="/" element={<Navigate to="/feeds" />} />
            <Route
              path="/feeds"
              element={
                <>
                  <Feeds /> <Footer />
                </>
              }
            />
            <Route
              path="/points-details"
              element={
                <>
                  <PointsDetail /> <Footer />
                </>
              }
            />
            <Route
              path="/points-exchange"
              element={
                <>
                  <PointsExchange /> <Footer />
                </>
              }
            />
            <Route
              path="/account"
              element={
                <>
                  <AccountSection /> <Footer />
                </>
              }
            />
          </>
        ) : (
          <Route
            path={pathname === "/log-in" ? "/" : pathname}
            element={<Navigate to="/log-in" />}
          />
        )}
        {(!userId || !userLoginStatus) && (
          <Route path="/log-in" element={<LogIn />} />
        )}
      </Routes>
    </>
  );
}

export default App;
